import React from 'react';
import { Box, Typography } from '@mui/material';

const NotFoundPage = () => (
  <Box sx={{ minHeight: '60vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
    <Typography variant="h2" color="primary" fontWeight={700} gutterBottom>
      404
    </Typography>
    <Typography variant="h5" color="text.secondary" gutterBottom>
      Page Not Found
    </Typography>
    <Typography variant="body1" color="text.secondary">
      The page you are looking for does not exist.
    </Typography>
  </Box>
);

export default NotFoundPage;
